export const productConnectionFragment = /* GraphQL */ `
  fragment productConnection on ProductConnection {
    pageInfo {
      hasNextPage
      hasPreviousPage
    }
    edges {
      cursor
      node {
        id
        title
        vendor
        handle
        tags
        productType
        availableForSale
        priceRange {
          minVariantPrice {
            amount
            currencyCode
          }
        }
        variants(first: 1) {
          edges {
            node {
              id
              title
              sku
              availableForSale
              quantityAvailable
              requiresShipping
              selectedOptions {
                name
                value
              }
              priceV2 {
                amount
                currencyCode
              }
              compareAtPriceV2 {
                amount
                currencyCode
              }
            }
          }
        }
        metafields(
          identifiers: [
            { namespace: "custom", key: "gender" }
            { namespace: "custom", key: "brand" }
            { namespace: "custom", key: "material" }
            { namespace: "custom", key: "gemstone" }
            { namespace: "custom", key: "style" }
          ]
        ) {
          value
          key
          namespace
        }
        images(first: 1) {
          pageInfo {
            hasNextPage
            hasPreviousPage
          }
          edges {
            node {
              originalSrc
              altText
              width
              height
            }
          }
        }
      }
    }
  }
`;
const getAllProductsQuery = /* GraphQL */ `
  query getAllProducts(
    $first: Int = 250
    $after: String
    $query: String = ""
    $sortKey: ProductSortKeys = RELEVANCE
    $reverse: Boolean = false
  ) {
    products(
      first: $first
      after: $after
      sortKey: $sortKey
      reverse: $reverse
      query: $query
    ) {
      ...productConnection
    }
  }

  ${productConnectionFragment}
`;
export default getAllProductsQuery;
